import ActionButton from 'ActionButton';

//
var script = {
  name: "CustomModal",
  meta: {
    description: "Componente modal estático personalizado",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    ActionButton
  },
  props: {
    showWithShadow: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: "Parámetro de entrada para mostrar efecto blur o efecto shadow",
        example: "true"
      }
    },
    value: {
      type: Boolean,
      required: true,
      default: false,
      meta: {
        description: "Parámetro de entrada",
        example: "true"
      }
    },
    iconColor: {
      type: String,
      required: false,
      meta: {
        description: "Especifica el color del icono del Modal",
        example: "#2db782"
      }
    },
    title: {
      type: String,
      required: true,
      meta: {
        description: "Especifica el encabezado del modal",
        example: "Texto requerido"
      }
    },
    showSave: {
      type: Boolean,
      required: false,
      default: true,
      meta: {
        description: "Propiedad para mostrar opción de guardar",
        example: "true"
      }
    },
    saveText: {
      type: String,
      required: false,
      default: "Guardar",
      meta: {
        description: "Acción de guardar el texto",
        example: "Guardar"
      }
    },
    saveIcon: {
      type: String,
      required: false,
      default: () => "",
      meta: {
        description: "Icono de guardar",
        example: "fas fa-check"
      }
    },
    cancelIcon: {
      type: String,
      required: false,
      default: "fas fa-times-circle",
      meta: {
        description: "Icono de cancelar",
        example: "fas fa-times-circle"
      }
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: true,
      meta: {
        description: "Propiedad para mostrar opción de cancelar",
        example: "true"
      }
    },
    showTopClose: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: "Muestra la opción Cerrar en la parte superior del modal",
        example: "true"
      }
    },
    cancelText: {
      type: String,
      required: false,
      default: "Cancelar",
      meta: {
        description: "Acción de revocar el texto",
        example: "Cancelar"
      }
    },
    icon: {
      type: String,
      required: false,
      default: "fa-plus",
      meta: {
        description: "Propiedad para el icono",
        example: "fa-plus"
      }
    },
    isCentered: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isTop: {
      type: Boolean,
      required: false,
      default: () => false
    },
    width: {
      type: String,
      required: false,
      default: () => "650px"
    },
    footerClass: {
      type: [String, Object],
      default: () => null
    },
    fade: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    idModal() {
      return `CustomModal_${this._uid}`;
    },

    customFooter() {
      return !!this.$slots['footer-content'];
    }

  },
  methods: {
    cancel() {
      this.$emit("cancel", false);
    },

    save() {
      this.$emit("save");
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [_vm.showWithShadow ? 'modal shadow-body' : 'modal blur', {
      'show-modal': _vm.value,
      'fade': _vm.fade
    }],
    attrs: {
      "id": _vm.idModal,
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: {
      'modal-dialog-custom': !_vm.isCentered && !_vm.isTop,
      'modal-dialog-centered': _vm.isCentered
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    style: {
      width: _vm.width
    }
  }, [_c('div', {
    staticClass: "modal-header shadow align-items-center"
  }, [_c('div', {
    staticClass: "modal-title",
    class: _vm.titleClass
  }, [_c('div', {
    staticClass: "border-icon"
  }, [_c('em', {
    staticClass: "text-orange",
    class: ['fa', _vm.icon],
    style: "color:" + _vm.iconColor + " !important"
  })]), _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _vm.showTopClose ? _c('span', {
    staticClass: "close-border p-1 mr-2 mt-0",
    on: {
      "click": _vm.cancel
    }
  }, [_c('em', {
    staticClass: "fas fa-window-close close-ico"
  }), _vm._v(" " + _vm._s(_vm.cancelText) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    class: _vm.footerClass
  }, [_vm._t("content-footer"), _vm._v(" "), !_vm.customFooter ? [_vm.showCancel && !_vm.showTopClose ? _c('action-button', {
    attrs: {
      "i": _vm.cancelIcon,
      "variant": "outline-danger",
      "text": _vm.cancelText
    },
    on: {
      "click": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), _vm.showSave ? _c('action-button', {
    staticClass: "px-4",
    attrs: {
      "i": _vm.saveIcon,
      "variant": "success",
      "text": _vm.saveText
    },
    on: {
      "click": _vm.save
    }
  }) : _vm._e()] : _vm._e()], 2)])])]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-d5ed51ec_0", {
    source: "@charset \"UTF-8\";.show-modal[data-v-d5ed51ec]{display:block}.shadow-body[data-v-d5ed51ec]{background:rgba(0,0,0,.4)}.blur[data-v-d5ed51ec]{backdrop-filter:blur(8px);overflow-y:auto}.modal .modal-dialog-custom[data-v-d5ed51ec]{padding-top:15vh}.modal .modal-dialog[data-v-d5ed51ec]{max-width:100vw}.modal .modal-dialog .modal-content[data-v-d5ed51ec]{margin:auto}.modal .modal-dialog .modal-content .modal-header[data-v-d5ed51ec]{padding:8px}.modal .modal-dialog .modal-content .modal-header .modal-title[data-v-d5ed51ec]{background:transparent linear-gradient(90deg,#fff 0,#e8e8e8 100%) 0 0 no-repeat padding-box;border-radius:26px;padding:4px 15px;font:900 16px Lato}.modal .modal-dialog .modal-content .modal-header .modal-title .border-icon[data-v-d5ed51ec]{background:#fff 0 0 no-repeat padding-box;box-shadow:0 3px 6px #00000029;border-radius:50px;padding-left:4px;padding-right:4px;margin-right:5px;display:inline}.modal .modal-dialog .modal-content .modal-header .close-border[data-v-d5ed51ec]{border:1px solid #2db782;border-radius:50px;display:inline-block;font-family:Lato,sans-serif;font-weight:400;font-size:1.125rem;line-height:1.6em;text-align:center;width:7.1875rem;height:2.6875‬rem;cursor:pointer;color:#2db782}.modal .modal-dialog .modal-content .modal-footer[data-v-d5ed51ec]{border-top:none;padding-top:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-d5ed51ec";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installCustomModal(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomModal', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
